import scrollToElement from "scroll-to-element"

export function handleMenuLinkClick(url, event) {
  if (typeof "undefined" !== window && url.includes("#")) {
    const [anchorPath, anchor] = url.split("#")

    if (window.location.pathname === anchorPath) {
      event.preventDefault()
      scrollToElement(`#${anchor}`, {
        offset: -75,
        ease: "inOutCirc",
        duration: 1000,
      })
    }
  }
}
